






















import { PropType, defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import { useUiHelpers } from '~/composables';
import type { Aggregation } from '~/modules/GraphQL/types';
import { getProductFilterByCategoryCommand } from '~/modules/catalog/category/components/filters/command/getProductFilterByCategoryCommand';
import { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import { isFilterEnabled } from '~/modules/catalog/category/config/FiltersConfig';
import { useFilters } from '../filters/useFilters';

export default defineComponent({
  components: {
    SvgImage,
    SfButton,
    JetUiButton,
  },
  props: {
    sortBy: {
      type: Object as PropType<SortingModel>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    catUid: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedSort = ref(props.sortBy.selected);
    const selectedPrice = ref(null);
    const filters = ref<Aggregation[]>([]);
    const isLoading = ref(props.isLoading);
    const removableFilters = ref([]);
    const { selectedFilters, selectFilter, getRemovableFilters } = useFilters();

    const uiHelpers = useUiHelpers();
    const doChangeSorting = () => {
      uiHelpers.changeSorting(selectedSort.value, false);
      emit('reloadProducts');
    };

    const doApplyFilters = (filter: Aggregation, option) => {
      selectFilter(filter, option);
      uiHelpers.changeFilters(selectedFilters.value, false);
      updateRemovableFilters();
      if (window?.scroll) {
        window.scroll(0, 0);
      }
      emit('reloadProducts');
    };

    const doClearFilters = () => {
      uiHelpers.clearFilters(false);
      selectedFilters.value = {};
      selectedPrice.value = null;
      updateRemovableFilters();
      emit('reloadProducts');
    };

    const updateRemovableFilters = () => {
      removableFilters.value = getRemovableFilters(filters.value, selectedFilters.value);
    };

    onMounted(async () => {
      const loadedFilters = await getProductFilterByCategoryCommand.execute({ eq: props.catUid });
      filters.value = loadedFilters.filter((filter) => isFilterEnabled(filter.attribute_code));
      
      updateRemovableFilters();
      const priceFilter = filters.value.find((filter) => filter.attribute_code === 'price');
      if (!removableFilters.value.some((filter) => filter.id === 'price')) {
        isLoading.value = false;
        return;
      }
      selectedPrice.value = priceFilter?.options.find((option) => option.value === removableFilters.value.find((filter) => filter.id === 'price').value);
      isLoading.value = false;
    });

    return {
      doChangeSorting,
      selectedSort,
      filters,
      selectFilter,
      doApplyFilters,
      selectedFilters,
      selectedPrice,
      doClearFilters,
    };
  },
});
